import { Level } from "./level.js"

export class Flat extends Level {
    constructor(key, level, options) {
        if (new.target === Flat) throw new TypeError("Cannot construct [Flat] instances directly")
        super(key, level, { ...options, background: "assets/flat/background.jpg", music: "music-house" });
        this._furniture = null
        this._layout = {
            ...this._layout, flat: {
                floor: [
                    {
                        "name": "bedroom-carpet",
                        "positions": {"left": 3573, "top": 445},
                    },
                    {
                        "name": "top-carpet",
                        "positions": {"left": 1349, "top": 823},
                    },
                    {
                        "name": "stairs",
                        "positions": {"left": 2478, "top": 714},
                    },
                    {
                        "name": "bottom-carpet",
                        "positions": {"left": 3482, "top": 1479},
                    },
                    {
                        "name": "kitchen-tiles",
                        "positions": {"left": 1289, "top": 1684},
                    }
                ],
                article: [
                    {
                        "name": "bottom-wall",
                        "positions": {"left": 0, "top": 753},
                    },
                    {
                        "name": "top-wall",
                        "positions": {"left": 920, "top": 85},
                    },
                    {
                        "name": "bedroom-top-wall",
                        "positions": {"left": 2660, "top": 0},
                    },
                    {
                        "name": "bedroom-bottom-wall",
                        "positions": {"left": 2662, "top": 906},
                    },
                    {
                        "name": "small-light-wall-1",
                        "positions": {"left": 2635, "top": 535},
                    },
                    {
                        "name": "small-light-wall-2",
                        "positions": {"left": 920, "top": 535},
                    },
                    {
                        "name": "small-light-wall-3",
                        "positions": {"left": 920, "top": 710},
                    },
                    {
                        "name": "small-light-wall-4",
                        "positions": {"left": 920, "top": 875},
                    },
                    {
                        "name": "small-light-wall-5",
                        "positions": {"left": 920, "top": 974},
                    },
                    {
                        "name": "armchair-1",
                        "positions": {"left": 0, "top": 1183},
                    },
                    {
                        "name": "armchair-2",
                        "positions": {"left": 0, "top": 1825},
                    },
                    {
                        "name": "armchair-3",
                        "positions": {"left": 1293, "top": 958},
                    },
                    {
                        "name": "armchair-flipped-1",
                        "positions": {"left": 1839, "top": 958},
                    },
                    {
                        "name": "armchair-flipped-2",
                        "positions": {"left": 3915, "top": 1473},
                    },
                    {
                        "name": "armchair-flipped-3",
                        "positions": {"left": 3915, "top": 1808},
                    },
                    {
                        "name": "bedroom-bed",
                        "positions": {"left": 3739, "top": 389},
                    },
                    {
                        "name": "bedroom-stool",
                        "positions": {"left": 3937, "top": 689},
                    },
                    {
                        "name": "chairs-left",
                        "positions": {"left": 391, "top": 1534},
                    },
                    {
                        "name": "chairs-right",
                        "positions": {"left": 914, "top": 1534},
                    },
                    {
                        "name": "closet-closed",
                        "positions": {"left": 3551, "top": 1085},
                    },
                    {
                        "name": "closet-open-empty",
                        "positions": {"left": 2358, "top": 297},
                    },
                    {
                        "name": "counter-top-left",
                        "positions": {"left": 1289, "top": 1530},
                    },
                    {
                        "name": "desk-chair-1",
                        "positions": {"left": 3669, "top": 2196},
                    },
                    {
                        "name": "desk-chair-2",
                        "positions": {"left": 3267, "top": 713},
                    },
                    {
                        "name": "desk-1",
                        "positions": {"left": 3579, "top": 2253},
                    },
                    {
                        "name": "desk-2",
                        "positions": {"left": 3177, "top": 771},
                    },
                    {
                        "name": "fridge",
                        "positions": {"left": 2252, "top": 1448},
                    },
                    {
                        "name": "lamp-1",
                        "positions": {"left": 390, "top": 930,},
                    },
                    {
                        "name": "lamp-2",
                        "positions": {"left": 3228, "top": 1127},
                    },
                    {
                        "name": "sofa",
                        "positions": {"left": 1470, "top": 707},
                    },
                    {
                        "name": "left-counter-bottom",
                        "positions": {"left": 1288, "top": 2023},
                    },
                    {
                        "name": "right-counter-bottom",
                        "positions": {"left": 2630, "top": 1791},
                    },
                    {
                        "name": "right-counter-top",
                        "positions": {"left": 2431, "top": 1539},
                    },
                    {
                        "name": "window-4",
                        "positions": {"left": 3700, "top": 78},
                    },
                ],
                furniture:[
                    {
                        "name": "dining-table",
                        "positions": {"left": 500, "top": 1487},
                    },
                    {
                        "name": "bedroom-drawer",
                        "positions": {"left": 2751, "top": 250},
                    },
                    {
                        "name": "coffee-table",
                        "positions": {"left": 1532, "top": 952},
                    },
                    {
                        "name": "small-table",
                        "positions": {"left": 1150, "top": 423},
                    },
                    {
                        "name": "middle-counter",
                        "positions": {"left": 1669, "top": 1952},
                    },
                    {
                        "name": "window-1",
                        "positions": {"left": 1354, "top": 200},
                    },
                    {
                        "name": "window-2",
                        "positions": {"left": 2012, "top": 200},
                    },
                    {
                        "name": "window-3",
                        "positions": {"left": 3191, "top": 78},
                    },
                    {
                        "name": "door",
                        "positions": {"left": 1706, "top": 283},
                    }
                ]
            }
        }
    }
    preload() {
        super.preload()
        for (let [group, info] of Object.entries(this.layout.flat)) {
            info.forEach(i => this.load.image(i.name, `assets/flat/${group}/${i.name}.png`))
        }
    }
    create() {
        super.create()
        let floor = this.physics.add.staticGroup();
        this.layout.flat.floor.forEach(a => {
            floor.create(a.positions.left, a.positions.top, a.name).setOrigin(0, 0).refreshBody()
        })
        let articles = this.physics.add.staticGroup();
        this.layout.flat.article.forEach(a => {
            let so = articles.create(a.positions.left, a.positions.top, a.name).setOrigin(0).refreshBody()
            so.setSize(so.body.width, so.body.height - 155, false)
        })
        this.physics.add.collider(this.bob, [articles]);
        this._furniture = this.physics.add.staticGroup();
        this.layout.flat.furniture.forEach(a => {
            let so = this._furniture.create(a.positions.left, a.positions.top, a.name).setOrigin(0).refreshBody()
            so.setSize(so.body.width, so.body.height - 155, false)
        })
    }
}